import { css, type DefaultTheme, type FlattenInterpolation, type ThemeProps } from 'styled-components';
import { TagType } from '../enums/TagType';

export const getTagStyleByType = (type?: TagType): FlattenInterpolation<ThemeProps<DefaultTheme>> => {
  switch (type) {
    case TagType.Info:
      return css`
        background-color: ${({ theme }) => theme.color.core.blue.main[100]};
        border-color: ${({ theme }) => theme.color.core.blue.main[700]};
        color: ${({ theme }) => theme.color.core.blue.main[700]};
        svg {
          color: ${({ theme }) => theme.color.core.blue.main[700]};
        }
      `;
    case TagType.Success:
      return css`
        background-color: ${({ theme }) => theme.color.core.green.main[100]};
        border-color: ${({ theme }) => theme.color.core.green.main[700]};
        color: ${({ theme }) => theme.color.core.green.main[700]};
        svg {
          color: ${({ theme }) => theme.color.core.green.main[700]};
        }
      `;
    case TagType.Warning:
      return css`
        background-color: ${({ theme }) => theme.color.core.orange.main[100]};
        border-color: ${({ theme }) => theme.color.core.orange.main[900]};
        color: ${({ theme }) => theme.color.core.orange.main[900]};
        svg {
          color: ${({ theme }) => theme.color.core.orange.main[900]};
        }
      `;
    case TagType.Error:
      return css`
        background-color: ${({ theme }) => theme.color.core.red.main[100]};
        border-color: ${({ theme }) => theme.color.core.red.main[700]};
        color: ${({ theme }) => theme.color.core.red.main[700]};
        svg {
          color: ${({ theme }) => theme.color.core.red.main[700]};
        }
      `;
    case TagType.Basic:
      return css`
        background-color: ${({ theme }) => theme.color.core.gray.main[100]};
        border-color: ${({ theme }) => theme.color.core.gray.main[500]};
        color: ${({ theme }) => theme.color.core.gray.main[500]};
        svg {
          color: ${({ theme }) => theme.color.core.gray.main[500]};
        }
      `;
    case TagType.Normal:
      return css`
        background-color: ${({ theme }) => theme.color.core.gray.complementary[100]};
        border-color: ${({ theme }) => theme.color.core.gray.main[300]};
        color: ${({ theme }) => theme.color.core.gray.main[800]};
        svg {
          color: ${({ theme }) => theme.color.core.gray.main[800]};
        }
      `;
    default:
      return css`
        background-color: ${({ theme }) => theme.color.theme.primary};
        border: none;
        color: ${({ theme }) => theme.color.grey.white};
        svg {
          color: ${({ theme }) => theme.color.grey.white};
        }
        &:hover {
          background-color: ${({ theme }) => theme.color.semantic.primary.background.hover};
        }
      `;
  }
};
